/**
 * 文档上下文定义
 * 定义文档数据和操作的React上下文
 *
 * 核心功能：
 * 1. 定义上下文接口
 * 2. 创建上下文对象
 */
import { createContext } from 'react';
/**
 * 创建文档上下文
 * 初始值为undefined，需要在Provider中设置
 */
export const DocumentContext = createContext(undefined);
//# sourceMappingURL=DocumentContext.js.map